import { keepPreviousData } from '@tanstack/react-query';
import { AGGREGATE_NAMES, LOAN_REQUEST_OFFER_STATUS, LOAN_REQUEST_RESOLVERS } from 'cpool-constants';
import { schemaLoanRequestResolver_GetAcceptedOfferCounts } from 'cpool-tables/backend-resolvers';
import { z } from 'zod';

import { useAggregateQuery } from '~/queryUtils/useQuery';
import { useQueryPositionStore } from '~/store/queryPositionStore.ts';
import { queryKeys } from '~/utils/queryKeys';

export const schemaAcceptedOfferCounts = z.record(z.nativeEnum(LOAN_REQUEST_OFFER_STATUS), z.number());
export type Schema_AcceptedOfferCounts = z.infer<typeof schemaAcceptedOfferCounts>;

export const useAcceptedOfferCounts = (loanRequestId: string) => {
    const queryKey = queryKeys.getAcceptedOfferCounts(loanRequestId);

    const queryPosition = useQueryPositionStore((state) => state.positions[JSON.stringify(queryKey)]);

    return useAggregateQuery({
        acl: { loanRequestId },
        aggregateName: AGGREGATE_NAMES.LOAN_REQUEST,
        resolverName: LOAN_REQUEST_RESOLVERS.getAcceptedOfferCounts,
        schema: schemaLoanRequestResolver_GetAcceptedOfferCounts,
        searchParams: { id: loanRequestId, position: queryPosition },
        tanstack: {
            placeholderData: keepPreviousData,
        },
    });
};
